import { DicomMetadataStore } from '@ohif/core';
import React, { useState, useEffect } from 'react';
import { GenerateQRModal } from '../GenerateQr/QrGenerator';
import { useLocation } from 'react-router';

interface QRCodeButtonProps {
  label?: string;
  className?: string;
  instanceUid?: string;
}

const QRCodeButton: React.FC<QRCodeButtonProps> = ({
  label = 'Generar QR',
  className = '',
  instanceUid = '',
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [qrValue, setQrValue] = useState('');
  const [loading, setLoading] = useState(true);
  const [instanceMeta, setInstanceMeta] = useState<any>(null);
  const location = useLocation();

  const isTemporalView = location.pathname.includes('temporalView');
  const fetchStudyMeta = async (attempts = 0) => {
    try {
      const studyMeta = await DicomMetadataStore.getStudy(String(instanceUid));

      if (studyMeta?.series?.length) {
        const instance = studyMeta.series[0].instances[0];
        setInstanceMeta(instance);
      } else {
        setInstanceMeta(null);
      }
    } catch (error) {
      console.error('Error fetching study data:', error);
      setInstanceMeta(null);
    } finally {
      setLoading(false);
      if (!instanceMeta && attempts < 5) {
        console.log(`Retrying... Attempt ${attempts + 1}`);
        setTimeout(() => fetchStudyMeta(attempts + 1), 1000);
      }
    }
  };

  useEffect(() => {
    fetchStudyMeta();
  }, [instanceUid, isTemporalView]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!instanceMeta) {
    return null;
  }

  const instanceData = {
    StudyDate: instanceMeta.StudyDate || '',
    InstitutionName: instanceMeta.InstitutionName || '',
    ReferringPhysicianName: instanceMeta.ReferringPhysicianName || '',
    StationName: instanceMeta.StationName || '',
    PerformingPhysicianName: instanceMeta.PerformingPhysicianName || '',
    NameOfPhysiciansReadingStudy: instanceMeta.NameOfPhysiciansReadingStudy || '',
    OperatorsName: instanceMeta.OperatorsName || '',
    ManufacturerModelName: instanceMeta.ManufacturerModelName || '',
    PatientName: instanceMeta.PatientName ? instanceMeta.PatientName[0].Alphabetic : null,
    ProtocolName: instanceMeta.ProtocolName || '',
  };
  const fecha = instanceData.StudyDate
    ? new Date(
      instanceData.StudyDate.substring(0, 4),
      instanceData.StudyDate.substring(4, 6) - 1,
      instanceData.StudyDate.substring(6, 8)
    ).toLocaleDateString()
    : 'Fecha no disponible';
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleButtonClick = () => {
    setIsModalOpen(true);
    const nombre = instanceData.PatientName;
    const tipo = instanceData.ProtocolName || 'Protocolo no disponible';

    const qrData = `Nombre: ${nombre} \nProtocolo: ${tipo} \nFecha: ${fecha}`;
    setQrValue(qrData);
  };

  return (
    <div>
      <button
        onClick={handleButtonClick}
        className={`bg-secondary-main hover:bg-secondary-light flex w-full items-center justify-center gap-2 rounded p-2 text-white sm:justify-between ${className}`}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          className="bi bi-qr-code"
          viewBox="0 0 16 16"
        >
          <path d="M2 2h2v2H2z" />
          <path d="M6 0v6H0V0zM5 1H1v4h4zM4 12H2v2h2z" />
          <path d="M6 10v6H0v-6zm-5 1v4h4v-4zm11-9h2v2h-2z" />
          <path d="M10 0v6h6V0zm5 1v4h-4V1zM8 1V0h1v2H8v2H7V1zm0 5V4h1v2zM6 8V7h1V6h1v2h1V7h5v1h-4v1H7V8zm0 0v1H2V8H1v1H0V7h3v1zm10 1h-1V7h1zm-1 0h-1v2h2v-1h-1zm-4 0h2v1h-1v1h-1zm2 3v-1h-1v1h-1v1H9v1h3v-2zm0 0h3v1h-2v1h-1zm-4-1v1h1v-2H7v1z" />
          <path d="M7 12h1v3h4v1H7zm9 2v2h-3v-1h2v-1z" />
        </svg>

        {loading ? 'Generado' : 'Generar Qr'}
      </button>
      <GenerateQRModal
        open={isModalOpen}
        closeModal={handleCloseModal}
        qrValue={qrValue}
      />
    </div>
  );
};

export default QRCodeButton;
